<!-- 登录界面 -->
<template>
  <div class="bgimg">
    <div class="login">
      <!-- 标题栏 -->
      <div class="login-title">
        <!-- 标题 -->
        <div class="title">可视化实时指挥平台</div>
      </div>
      <!-- 登录框 -->
      <div class="login-box">
        <div class="inputStyle">
          <el-input
            placeholder="请输入用户名"
            prefix-icon="el-icon-user-solid"
            size="small"
            v-model="loginform.userName"
          >
          </el-input>
          <el-input
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            size="small"
            show-password
            v-model="loginform.userPassword"
          >
          </el-input>
          <el-button
            type="primary"
            class="login-btn"
            @keyup.enter="keyDown(e)"
            @click="login"
          >
            登录
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loginform: {
        userName: "",
        userPassword: ""
      }
    };
  },
  created() {
    this.checkURLFormat();
  },
  mounted() {
    // 绑定监听事件
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  },
  methods: {
    checkURLFormat() {
      const hash = window.location.hash; // 获取哈希部分
      const queryString = hash.split("?")[1]; // 提取查询参数部分
      if (queryString) {
        const params = new URLSearchParams(queryString);

        if (params.has("f")) {
          // 获取 f 的值
          const fValue = params.get("f");
          // 用 , 分割 f 的值
          const [encodedValue1, encodedValue2] = fValue.split(",");

          // 对两个值进行 Base64 解码
          if (encodedValue1 && encodedValue2) {
            try {
              this.loginform.userName = atob(encodedValue1); // 解码第一个值
              this.loginform.userPassword = atob(encodedValue2); // 解码第二个值
              this.iframeLogin();
            } catch (error) {
              console.log("URL 格式错误1");
            }
          } else {
            console.log("URL 格式错误2"); // 如果分割后值不全，格式错误
          }
        } else {
          console.log("URL 格式错误");
        }
      } else {
        // console.log("URL 中没有查询参数");
      }
    },
    //iframe 登录方法
    iframeLogin() {
      this.$axios({
        method: "post",
        url: `${this.$api}/login`,
        data: this.qs.stringify(this.loginform)
      })
        .then(res => {
          if (res.data.status == 200) {
            window.sessionStorage.setItem(
              "loginInfo",
              window.JSON.stringify(res.data.data)
            );
            window.sessionStorage.setItem(
              "token",
              window.JSON.stringify(res.data.data.token)
            );
            this.$router.push({ path: "/liveVideo" });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    // 登录方法
    login() {
      this.$axios({
        method: "post",
        url: `${this.$api}/login`,
        data: this.qs.stringify(this.loginform)
      })
        .then(res => {
          if (res.data.status == 200) {
            window.sessionStorage.setItem(
              "loginInfo",
              window.JSON.stringify(res.data.data)
            );
            window.sessionStorage.setItem(
              "token",
              window.JSON.stringify(res.data.data.token)
            );
            this.$router.push({ path: "/dataBoard" });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error); //请求失败返回的数据
        });
    },
    // 点击回车键登录
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13) {
        this.login(); // 定义的登录方法
      }
    }
  }
};
</script>

<style lang="less" scoped>
/* ========login页面========= */

/* 背景图片 */
.bgimg {
  width: 100%;
  height: 100%;
  /* background-color: burlywood; */
  background-image: url(../assets/img/login/login-bg.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  /* 背景图像固定 */
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 标题栏 */
.login-title {
  width: 450px;
  height: 60px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/login/login-title.png);
  background-size: 100% 100%;
}
/* 标题文字 */
.title {
  font-size: 1.7rem;
  font-weight: bold;
  background-image: linear-gradient(60deg, #157afd, #76deeb);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  line-height: 60px;
  text-align: center;
}

/* 登录框*/
.login-box {
  margin-top: 100px;
  width: 450px;
  height: 400px;
  background-repeat: no-repeat;
  background-image: url(../assets/img/login/login-box.png);
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: start;
}

/* 输入框外面div */
.inputStyle {
  width: 250px;
  margin-top: 50px;
}

/* element-input背景颜色改为透明，修改输入字体颜色 */
/deep/ .el-input__inner {
  background-color: transparent;
  color: #0571fe;
  margin: 15px 0;
}

/* 登录按钮 */
.login-btn {
  width: 250px;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue